(function() {
var productHandle = window.location.pathname.split('/').pop();
if (!window.localStorage) return;

var maxProducts = 5; // Maximum number of products to store
var recentlyViewed = JSON.parse(localStorage.getItem('recentlyViewed')) || [];

// Remove the product if it already exists
recentlyViewed = recentlyViewed.filter(function(handle) {
return handle !== productHandle;
});

// Add the product to the beginning of the list
recentlyViewed.unshift(productHandle);

// Limit the list to the maximum number of products
if (recentlyViewed.length > maxProducts) {
recentlyViewed.pop();
}

localStorage.setItem('recentlyViewed', JSON.stringify(recentlyViewed));
})();
